// import { useState } from "react";
import DownArrow from "../assets/Keyboard arrow down.png";
import Tags from "../assets/Category.png";

const FilterPanel = ({ filters, tags, industries, onFilterChange, type }) => {
  // const [openSections, setOpenSections] = useState({
  //   occupation: true,
  //   tags: true,
  //   industry: true,
  //   extras: true, // sponsored + internship
  // });

  // const toggleSection = (section) => {
  //   setOpenSections((prev) => ({ ...prev, [section]: !prev[section] }));
  // };

  return (
    <div className=" m-auto  mb-6 flex flex-col font-sans">


      <div className="flex flex-col gap-3 mb-4">
        {type.map((ind) => {
          return (
            <button
              className={`w-full py-2 rounded-full border font-medium text-sm transition ${filters.occupation === ind
                ? "bg-gray-100 text-[#234075] border-[#234075]"
                : "bg-white text-gray-900 border-gray-200 hover:bg-gray-50"
                }`}
              onClick={() => onFilterChange({ ...filters, occupation: ind })}
            >
              {ind}
            </button>
          );
        })}
      </div>

      <div className="flex flex-col gap-2 mb-2 w-full">
        <label className="text-sm font-semibold text-black">Select Tags</label>
        <div className="relative flex items-center w-full bg-[#fafbfc] border border-gray-200 rounded-xl px-3 h-13">
          <span className="absolute left-4 z-10 flex items-center">
            <img src={Tags} alt="Tags" className="w-5 h-5" />
          </span>
          <select
            value={filters.tag || ""}
            onChange={(e) =>
              onFilterChange({ ...filters, tag: e.target.value })
            }
            className="w-full pl-11 pr-10 py-3 bg-transparent text-sm font-semibold text-gray-800 outline-none appearance-none"
          >
            <option value="">Tags</option>
            {tags.map((tag) => (
              <option key={tag} value={tag}>
                {tag}
              </option>
            ))}
          </select>
          <span className="absolute right-3 z-10 pointer-events-none">
            <img src={DownArrow} alt="DownArrow" className="w-4 h-4" />
          </span>
        </div>
      </div>

      <div className="flex flex-col gap-2 mb-2 w-full">
        <label className="text-sm font-semibold text-black">
          Select industry Type
        </label>
        <div className="relative flex items-center w-full bg-[#fafbfc] border border-gray-200 rounded-xl px-3 h-13">
          <span className="absolute left-4 z-10 flex items-center">
            <img src={Tags} alt="industry" className="w-5 h-5" />
          </span>
          <select
            value={filters.industry || ""}
            onChange={(e) =>
              onFilterChange({ ...filters, industry: e.target.value })
            }
            className="w-full pl-11 pr-10 py-3 bg-transparent text-sm font-semibold text-gray-800 outline-none appearance-none"
          >
            <option value="">Industry Type</option>
            {industries?.map((ind) => (
              <option key={ind} value={ind}>
                {ind}
              </option>
            ))}
          </select>
          <span className="absolute right-3 z-10 pointer-events-none">
            <img src={DownArrow} alt="DownArrow" className="w-4 h-4" />
          </span>
        </div>
      </div>

      <div className="mt-4 w-full">
        <label className="flex items-center gap-2 cursor-pointer text-sm font-medium text-gray-800">
          <input
            type="checkbox"
            checked={filters.sponsored || false}
            onChange={(e) =>
              onFilterChange({ ...filters, sponsored: e.target.checked })
            }
            className="accent-[#135879]"
          />
          <span>Show Sponsored Only</span>
        </label>
      </div>
      <div className="flex items-center gap-2 mt-3">
        <input
          type="checkbox"
          id="internship"
          className="accent-[#135879]"
          checked={filters.internship}
          onChange={() =>
            onFilterChange({ ...filters, internship: !filters.internship })
          }
        />
        <label
          htmlFor="internship"
          className="flex items-center gap-2 cursor-pointer text-sm font-medium text-gray-800"
        >
          Internship Available For Students
        </label>
      </div>
    </div>
  );
};

export default FilterPanel;
